import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/driving-info/DrivingInfoTripContent/.eu';
import Kr from '@di-shared/features/history/driving-info/DrivingInfoTripContent/.kr';

export interface DrivingInfoTripContentProps {
  vin: string;
  selectedDate: Date;
}

export default function DrivingInfoTripContent({vin, selectedDate}: DrivingInfoTripContentProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          selectedDate={selectedDate}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          selectedDate={selectedDate}
        />
      </Environment.Kr>
    </>
  );
}
